module.exports = __webpack_public_path__ + "img/Img-diwen-home.7193d1e5.png";